import React from 'react';

function SubscriptionBanner({ daysRemaining, onGoToSubscription, onDismiss }) {
  if (daysRemaining > 7) return null; // Ne pas afficher si plus de 7 jours

  const isUrgent = daysRemaining <= 2;

  return (
    <div className={`w-full px-6 py-3 ${
      isUrgent 
        ? 'bg-gradient-to-r from-red-600 to-red-700' 
        : 'bg-gradient-to-r from-orange-600 to-orange-700'
    } border-b border-white/10`}>
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <svg className="w-6 h-6 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          <div>
            <p className="font-semibold text-sm">
              {isUrgent 
                ? `⏰ Votre abonnement expire dans ${daysRemaining} jour${daysRemaining > 1 ? 's' : ''} !`
                : `Votre abonnement expire bientôt (${daysRemaining} jours restants)`
              }
            </p>
            <p className="text-xs text-white/80">
              Renouvelez maintenant pour continuer à profiter de votre musique sans interruption
            </p>
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          <button
            onClick={onGoToSubscription}
            className="px-4 py-2 bg-white text-black rounded-full text-sm font-bold hover:scale-105 transition-transform whitespace-nowrap"
          >
            Renouveler
          </button>
          <button
            onClick={onDismiss}
            className="w-8 h-8 rounded-full hover:bg-white/10 flex items-center justify-center transition-colors"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionBanner;
